import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export const formatDate = (dateString) => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    // Check if date is valid
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch {
    return '-';
  }
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    // Check if date is valid
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return '-';
  }
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  }).format(amount);
};

export const formatOrderNo = (orderNo) => {
  return `ORD-${String(orderNo).padStart(4, '0')}`;
};

export const getStatusLabel = (status) => {
  const labels = {
    'DRAFT': 'Erfasst',
    'ASSIGNED': 'Geplant',
    'IN_PROGRESS': 'In Bearbeitung',
    'DONE': 'Erledigt'
  };
  return labels[status] || status;
};

export const getStatusClass = (status) => {
  const classes = {
    'DRAFT': 'status-draft',
    'ASSIGNED': 'status-assigned',
    'IN_PROGRESS': 'status-in-progress',
    'DONE': 'status-done',
    'APPROVED': 'status-approved',
    'INVOICED': 'status-invoiced'
  };
  return classes[status] || 'status-draft';
};

export const calculateLineTotals = (lines = []) => {
  let totalNet = 0;
  let totalTax = 0;
  
  lines.forEach(line => {
    const lineNet = (line.qty || 0) * (line.unit_price_net || 0);
    const lineTax = lineNet * ((line.tax_rate || 19) / 100);
    totalNet += lineNet;
    totalTax += lineTax;
  });
  
  return {
    net: totalNet,
    tax: totalTax,
    gross: totalNet + totalTax
  };
};
